import { render, staticRenderFns } from "./OpenSourceRefer.vue?vue&type=template&id=a8ccf32e&scoped=true&"
import script from "./OpenSourceRefer.vue?vue&type=script&lang=js&"
export * from "./OpenSourceRefer.vue?vue&type=script&lang=js&"
import style0 from "./OpenSourceRefer.vue?vue&type=style&index=0&id=a8ccf32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ccf32e",
  null
  
)

export default component.exports